export enum POSTextHorizontalAlign {
	Left = 'left',
	Center = 'center',
	Right = 'right'
}

export enum POSTextVerticalAlign {
	Top = 'top',
	Middle = 'middle',
	Bottom = 'bottom'
}
